/* istanbul ignore file */
import { getEnvFromHost } from "utils/getEnvFromHost";

export default {
  "privacy-policy": "https://www.vodafone.cz/o-vodafonu/ke-stazeni/ochrana-soukromi/",
  "terms-and-conditions": `https://${
    getEnvFromHost(window.location.host) === "PROD" ? "" : `${getEnvFromHost(window.location.host).toLowerCase()}.`
  }cdn.offers.vodafone.com/tnc/cz/privacy-policy.html`,
  "help-and-support": "https://www.vodafone.cz/pece/",
  accessibility: "accessibility",
  "cookie-preferences": "cookie-preferences",
};
